import React from 'react';
import { Card, Button, Container } from 'react-bootstrap';
import AddOrderButton from './AddOrderButton';

export default function Product({ product }) {
  const { image, name, brand, description, price, _id } = product;

  let amount = price;
  // amount = parseFloat(price.toFixed(2));
  // amount = amount.toLocaleString('en');

  return (
    <div>
      {/* <Container className='flex-container'> */}
      <Card
        className='cart-item'
        style={{
          width: '20rem',
          height: '100%',
          margin: '5px 5px',
          padding: '0px',
        }}
      >
        <Card.Img className='card-item-img' variant='top' src={image} />

        <Card.Body>
          <Card.Title class='text-uppercase' className='cart-item-h4'>
            {name}
          </Card.Title>
          <Card.Text>
            <p>Brand: {brand}</p>
            <p>Price: Php {amount}</p>
            <Card.Link href={`/product/${_id}`}>Details</Card.Link>
          </Card.Text>
        </Card.Body>
        <AddOrderButton productId={_id} />
      </Card>
      {/* </Container> */}
    </div>
  );
}
